export default __webpack_public_path__ + "static/media/pic10-1.c86b2d4b.jpg";